import partials from "./partials";
import { SET } from "@/store/common/_mutations";
import axios from 'axios'
import { i18n } from "@/plugins/i18n";
import { cloneDeep } from "lodash";
import Errors from '@/classes/errors'

function findBySlug(slug, items) {
    const item = items.find((item) => item.slug === slug);
    return item ? item : null;
}

const formFields =
    ['building_id', 'apartment_id', 'email', 'tel', 'bathrooms', 'rooms', 'preferences', 'sanitary_equipment', 'message'];

const pageFormFields = {
    object: ['floor', 'apartment_id', 'email', 'tel'],
    stepper: ['confirmed_at', 'attachments', 'bathrooms', 'rooms', 'preferences', 'sanitary_equipment', 'pricing', 'message']
}

const selectionDefaults = {
    selection_id: null,
    confirmed_at: null,
    attachments: [],
    pricing: {},
    sanitary_equipment: {},
    rooms: [],
    bathrooms: [],
    loading: [],
    preferences: {},
    message: ''
}

export default {
    state: {
        ...cloneDeep(selectionDefaults),
        pageFormFields: pageFormFields,
        is_admin: null,
        confirmed_at: null,
        attachments: [],
        pricing: {},
        options: {},
        extras: {},
        sanitary_equipment: {},
        rooms: [],
        bathrooms: [],
        loading: [],
        preferences: {},
        alternative: true,
        initialized: false,
        ...partials.state,
    },

    getters: {
        bathrooms(state, getters) {
            return state.bathrooms.map((el) => {
                el.wallsCeramicTile = findBySlug(el.walls_ceramic_tile_slug, state.options.ceramic_tiles);
                el.floorCeramicTile = findBySlug(el.floor_ceramic_tile_slug, state.options.ceramic_tiles)
                return el;
            });
        },
        isDisabled(state, getters) {
            return state.confirmed_at ? true : false
        },
        hallwayFloorCeramicTile(state, getters) {
            return findBySlug(state.preferences.hallway_floor_ceramic_tile_slug, state.options.ceramic_tiles)
        },
        isLoading: (state, getters) => field => {
            return state.loading.includes(field)
        },
        ...partials.getters,

    },

    mutations: {
        ...partials.mutations,
        SET: (state, payload) => {
            SET(state, payload);
        },
        START_LOADING: (state, payload) => {
            state.loading.push(payload)
            SET(state, { loading: _.clone(state.loading) });
        },
        STOP_LOADING: (state, payload) => {
            SET(state, { loading: state.loading.filter((el) => el !== payload) });
        },
        SET_BATHROOM: (state, { bathroomIndex, updatables }) => {
            SET(state.bathrooms[bathroomIndex], updatables);
        },
        SET_ROOM: (state, { roomIndex, updatables }) => {
            SET(state.rooms[roomIndex], updatables);
        },
        SET_SANITARY_EQUIPMENT: (state, updatables) => {
            SET(state.sanitary_equipment, updatables);
        },
        SET_PREFERENCE: (state, updatables) => {
            SET(state.preferences, updatables);
        },
    },

    actions: {
        ...partials.actions,

        setBathroom({ state, getters, commit, dispatch }, updatables) {
            commit('SET_BATHROOM', updatables)
            dispatch('saveDebounced', 'stepper')
        },
        setRoom({ state, getters, commit, dispatch }, updatables) {
            commit('SET_ROOM', updatables)
            dispatch('saveDebounced', 'stepper')
        },
        setSanitaryEquipment({ state, getters, commit, dispatch }, updatables) {
            commit('SET_SANITARY_EQUIPMENT', updatables)
            dispatch('saveDebounced', 'stepper')
        },
        setPreference({ state, getters, commit, dispatch }, updatables) {
            commit('SET_PREFERENCE', updatables)
            dispatch('saveDebounced', 'stepper')
        },
        setMessage({ state, getters, commit, dispatch }, message) {
            commit('SET', { message })
            dispatch('saveDebounced', 'stepper')
        },
        saveDebounced({ state, getters, commit, dispatch }, page) {
            // TODO mingi debounce lahendus, et aeglase ühenduse korral hiljem tulev response ei kirjutaks üle....
            // või siis ehk näiteks kopeeri ja kirjuta ümber setFromDatabase action selliselt, et värskendaks ainult price (või ka updatitud väärtust?)
            dispatch('save', page)
        },

        save({ state, getters, commit, dispatch }, page) {

            if (state.confirmed_at) {
                commit('SET', {
                    errorSnackbarVisible: true,
                    errorSnackbarContent: i18n.t('You have already confirmed the preferences. Please contact us to update!')
                })
                return Promise.resolve();
            }

            commit('START_LOADING', page)

            const form = {
                page,
            }

            formFields.forEach(field => {
                form[field] = state[field]
            });
            return new Promise((resolve, reject) => {
                axios.post('save', form)
                    .then(response => {
                        state.error.clear();
                        dispatch('setFromDatabase', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        state.error.handleAxiosErrorResponse(error)
                        dispatch('setFromDatabase', form);
                        reject(error);
                    })
                    .then(() => {
                        setTimeout(() => {
                            commit('STOP_LOADING', page)
                        }, 300);
                    });
            });
        },

        checkValidity({ state, getters, commit, dispatch }) {
            commit('START_LOADING', 'checkValidity')

            const form = {}

            formFields.forEach(field => {
                form[field] = state[field]
            });

            return axios.post('check-validity', form)
                .then(response => {
                    state.error.clear();
                })
                .catch(error => {
                    state.error.handleAxiosErrorResponse(error)
                })
                .then(() => {
                    setTimeout(() => {
                        commit('STOP_LOADING', 'checkValidity')
                    }, 300);
                });
        },

        async resetSelection({ state, getters, commit, dispatch }, context) {
            const response = await axios.post("get-selection", context.$route.query);
            let selection = response.data

            if (!selection)
                selection = cloneDeep(selectionDefaults)

            selection.id = selection.id ? selection.id : selectionDefaults.selection_id

            dispatch("setFromDatabase", selection);
            commit('SET', { shouldValidateSteps: [] })
        },

        setFromDatabase({ state, getters, commit, dispatch }, data) {
            if (!data) {
                console.error('Data must not be empty!', data)
            }
            const updatables = {
                selection_id: data.id
            }
            for (let [page, fields] of Object.entries(pageFormFields)) {
                fields.forEach(field => {
                    if (data.hasOwnProperty(field) /* && data[field] */) {
                        updatables[field] = data[field]
                    }
                });
            }
            const errors = data.validationErrors
            if (errors && typeof errors === 'object') {
                const error = new Errors
                error.recordValidationErrors(errors)
                error.recordErrorMessage('Error')
                commit('SET', { error: error })
            }
            commit('SET', updatables)

        },

        async reset({ state, getters, commit, dispatch }) {
            commit('START_LOADING', 'reset')

            const response = await axios.post("reset", {
                building_id: state.building_id,
                apartment_id: state.apartment_id,
                email: state.email,
                tel: state.tel,
                page: 'object'
            });

            location.reload();
            commit('STOP_LOADING', 'reset')
        },
    },

    modules: {

    },
};
